import { Component, OnInit } from '@angular/core';
import { MyOverlayRef } from '../../overlay/myoverlay-ref';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-modal-text-area-for-array',
    standalone : true,
    imports: [CommonModule, FormsModule],
    templateUrl: './modal-text-area-for-array.component.html',
    styleUrls: ['./modal-text-area-for-array.component.scss']
})
export class ModalTextAreaForArrayComponent implements OnInit {
  public rw: boolean = false;
  public texte: string = '';

  constructor(private ref: MyOverlayRef) {}

  ngOnInit(): void {
    console.log('this.ref', this.ref);
    let data = this.ref?.data;
    console.log('data', data);

    if (this.ref?.data != null) {
      this.rw = data.rw;
      if (data.texte != undefined) this.texte = JSON.parse(JSON.stringify(data.texte));
    }
  }

  public close(sendUpdate: boolean = false) {
    if (!sendUpdate) this.ref.close();
    else this.ref.close(this.texte);
  }
}
